import { HIDE_SPINNER, SHOW_SPINNER } from "../actions/types";
import {
  SET_ADJUNTOS,
  SET_FOCUSED,
  SET_PROPERTY_ADJUNTO,
  SET_SINGLE_ADJUNTO,
  SET_SINGLE_ADJUNTO_PARAMS,
} from "../types/adjuntos";

const AdjuntoReducer = (state, { type, payload }) => {
  switch (type) {
    case SHOW_SPINNER:
      return { ...state, spinner: true };
    case HIDE_SPINNER:
      return { ...state, spinner: false };
    case SET_ADJUNTOS:
      return { ...state, adjuntos: payload };
    case SET_SINGLE_ADJUNTO:
      return { ...state, adjunto: payload };
    case SET_PROPERTY_ADJUNTO:
      const adjunto = { ...state.adjunto };
      const { key, value } = payload;
      adjunto[key] = value;
      return { ...state, adjunto };
    case SET_FOCUSED:
      return { ...state, focused: payload };
    case SET_SINGLE_ADJUNTO_PARAMS:
      return { ...state, params: payload };
    default:
      return { ...state };
  }
};
export default AdjuntoReducer;
